import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/** Résout un lien public : URL complète telle quelle, sinon préfixe par window.location.origin. */
export function resolvePublicLink(link, fallback = "") {
  const v = (link || fallback || "").trim();
  if (!v) return "";
  if (/^https?:\/\//i.test(v)) return v.replace(/\/$/, "");
  const path = v.startsWith("/") ? v : `/${v}`;
  return `${window.location.origin}${path}`;
}
